import { render, staticRenderFns } from "./TagContextmenu.vue?vue&type=template&id=00b8067d&scoped=true"
import script from "./TagContextmenu.vue?vue&type=script&lang=js"
export * from "./TagContextmenu.vue?vue&type=script&lang=js"
import style0 from "./TagContextmenu.vue?vue&type=style&index=0&id=00b8067d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b8067d",
  null
  
)

export default component.exports